module.exports = __webpack_public_path__ + "static/media/Eclectic+Gallery+Wall+DIY+Tutorial_0012.23e9b9db.jpeg";